import { MeteoHomeContext } from 'pages/meteo/[type]/[locality]';
import { Geopoint } from 'pleinchamp-api-client';
import { useContext } from 'react';
import { IconSizes } from '@components/icons/icon.types';
import { WeatherCodeIcon } from '@components/icons/meteo/WeatherCode';
import { MeteoHomeTabs } from '@meteo/business/Meteo.types';
import { computeMeteoInfoFromDateAndPostion, isItNight } from '@meteo/business/meteo.utils';
import style from '@meteo/components/MeteoWeatherTable/MeteoWeatherTableContent/MeteoWeatherTableContent.module.scss';
import { WeatherCode } from '@meteo/types';
import { usePlcRouter } from '@utils/customHooks';
import { buildTargetUrlWithUpdatedParam } from '@utils/url';
import { Dayjs } from 'dayjs';

interface Props {
  code?: WeatherCode;
  onMouseOver: () => void;
  date: Dayjs;
  formatHourByHour: boolean;
  isEmphasis: boolean;
  isLoading?: boolean;
  coordinates: Geopoint;
  forceDay: boolean;
}

function MeteoWeatherCodeHeader({
  code,
  forceDay,
  onMouseOver,
  date,
  formatHourByHour,
  isEmphasis,
  isLoading = false,
  coordinates,
}: Props) {
  const { latitude, longitude } = coordinates;
  const { sunrise, sunset } = computeMeteoInfoFromDateAndPostion(date.toDate(), latitude, longitude);
  const {
    day: { setData: setDay },
    defaultTab: { setData: setActiveTab },
  } = useContext(MeteoHomeContext);
  const router = usePlcRouter();
  const { pathname, query } = router;

  function handleHeaderClick() {
    if (setActiveTab) {
      setActiveTab(MeteoHomeTabs.HourByHour);
    }
    router.replace(pathname, buildTargetUrlWithUpdatedParam(pathname, 'type', MeteoHomeTabs.HourByHour, query), {
      shallow: true,
    });
    if (setDay) setDay(date.toString());
  }

  return (
    <th
      className={`${formatHourByHour ? '' : 'cursor-pointer'} ${isEmphasis ? style.emphasis : ''}`}
      onClick={formatHourByHour ? () => null : handleHeaderClick}
      onMouseEnter={onMouseOver}
    >
      {code === undefined || code === null ? null : (
        <WeatherCodeIcon
          height={44}
          isLoading={isLoading}
          night={!forceDay && isItNight(sunrise, sunset, date)}
          variant={IconSizes.tiny}
          weatherCode={code as number}
          width={44}
        />
      )}
    </th>
  );
}

export { MeteoWeatherCodeHeader };
